import { useContext, useEffect, useState, useRef } from "react";
import { Tab, TabList } from "@fluentui/react-tabs";
import CustomBreadCrumb from "../../components/CustomBreadCrumb";
import { TOAST_TYPE, USERTYPES, AuthRoutes } from "../../constants/Constants";
import userContext from "../../context/users/UserContext";
import { t } from "i18next";
import themeContext from "../../context/theme/ThemeContext";
import { Icon, PrimaryButton, TooltipHost, DirectionalHint } from "@fluentui/react";
import "../ReportTemplates/ReportTemplate.css";
import "../StudyList/StudyList.css";
import "../../components/ListView/ListViewStyles.css";
import "../../components/LisViewTable/ListViewTableStyles.css";
import SortPopupFilterSectionV4 from "../../components/ListViewV4/SortPopupFilterSectionV4";
import { QueryClient, QueryClientProvider } from "react-query";
import { useNavigate } from "react-router-dom";
import { deleteStyleApi, getStylesList } from "../../service/MasterService";
import loaderContext from "../../context/loader/LoaderContext";
import toastContext from "../../context/toast/ToastContext";
import ConfirmModal from "../../components/Modal/ConfirmModal";
import ListViewTableV3 from "../../components/ListViewV3/ListViewTableV3";
import SortPopupFilterSectionV2 from "../../components/ListViewV3/SortPopupFilterSectionV2";

const MyStyles = () => {
  const queryClient = new QueryClient();
  const { getThemeColor, getAlterColor } = useContext(themeContext);
  const { roles, loadByUsername, authenticated } = useContext(userContext);
  const { setLoaderRunning, ref } = useContext(loaderContext);
  const { showToastv2 } = useContext(toastContext);
  const [breadCrumbItems, setBreadCrumbItems] = useState([]);
  const [searchText, setSearchText] = useState("");
  const [pageIndex, setPageIndex] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [sortObj, setSortObj] = useState({
    sortFieldText: "",
    sortFieldValue: "",
    sortDir: false,
    selected: false,
  });
  const [filterObj, setFilterObj] = useState({
    filterInput: null,
    filterUpdate: 0,
  });
  const [dataQueryState, setDataQueryState] = useState(null);
  const [selectedRow, setSelectedRow] = useState(0);
  const [listViewLoading, setListViewLoading] = useState(false);
  const listViewRef = useRef(null);
  const [selectedStyle, setSelectedStyle] = useState(null);
  const [deletedId, setDeletedId] = useState();
  const [showDeleteConfirmModal, setShowDeleteConfirmModal] = useState(false);
  const [styleToDelete, setStyleToDelete] = useState(null);

  const navigate = useNavigate();

  const handleAddNewStyle = () => {
        navigate(AuthRoutes.ADD_STYLE);
  };

  useEffect(() => {
    setBreadCrumbItems([
      {
        text: t("Agentic Report Styles"),
        key: "my_styles",
      },
    ]);
  }, [roles]);

  useEffect(() => {
    if (!authenticated) {
      loadByUsername();
    }
  }, [authenticated]);

  useEffect(() => {
    if (dataQueryState && dataQueryState.data && dataQueryState.data.rows && dataQueryState.data.rows.length > 0) {
      setSelectedStyle(dataQueryState.data.rows[0]);
    }
  }, [dataQueryState]);

  const MyStylesTabSection = () => {
    return (
      <TabList
        style={{ marginLeft: "10px" }}
        className="tab-list-container-cmp tabList"
        selectedValue="tab_1"
      >
        <Tab
          key="tab_1"
          className="top-tab-cmp"
          id="tab_1"
          value="tab_1"
          style={{
            borderTop: "1px solid #7E7E7E",
            borderLeft: "1px solid #7E7E7E",
            borderRight: "1px solid #7E7E7E",
            borderBottom: "none",
            borderRadius: "10px 10px 0px 0px",
          }}
        >
          <div
            className="tabContent"
            style={{
              padding: "0px 15px",
              display: "flex",
              justifyContent: "center",
            }}
          >
            <Icon className="icon" />
            <h4 className="textContent-study-list highlight-tab">
              {t("My Styles")}
            </h4>
            <div className="hide-border-bottom-border-tabs"></div>
          </div>
        </Tab>
      </TabList>
    );
  };

  const handleApplyClick = (filterValue) => {
    console.log("Search applied with value:", filterValue);
    setFilterObj({
      filterInput: filterValue,
      filterUpdate: filterObj.filterUpdate + 1,
    });
  };

  const buttonsTopBar = [
    {
      key: "1",
      button: (
        <div className="add-button-list-view">
          <PrimaryButton
            text={"Add New Style"}
            className="common-default-active-button list-view-top-buttons-styles"
            onClick={handleAddNewStyle}
          />
        </div>
      ),
    },
  ];

  const fetchStylesData = async (options) => {
    setLoaderRunning(true);
    ref.current.continuousStart();

    try {
      const response = await getStylesList();
      console.log("Raw API response:", response);
      console.log("API response data:", response.data);
      console.log("API response data.data:", response.data.data);
      console.log("Styles:", response.data.data.styles);
      console.log("Report Templates:", response.data.data.reportTemplates);

      if (response.status !== 200 || response.data.result !== "SUCCESS") {
        throw new Error("Failed to fetch styles");
      }
      
      // Get styles from the new response format
      let results = response.data.data.styles || [];
      let reportTemplates = response.data.data.reportTemplates || [];

      console.log("Results after extraction:", results);
      console.log("Report Templates after extraction:", reportTemplates);

      // Store reportTemplates in dataQueryState for later use
      const processedData = {
        rows: results,
        pageCount: Math.ceil(results.length / options.pageSize),
        reportTemplates: reportTemplates // Add this to the data structure
      };

      console.log("Processed data being returned:", processedData);

      // Apply client-side filtering if search text exists
      if (options.filterObj.filterInput) {
        const searchTerm = options.filterObj.filterInput.toLowerCase();
        results = results.filter(item => 
          (item.title && item.title.toLowerCase().includes(searchTerm)) ||
          (item.styles && item.styles.toLowerCase().includes(searchTerm))
        );
      }

      // Apply client-side sorting
      if (options.sortObj.sortFieldValue && options.sortObj.sortFieldValue.length > 0) {
        const sortField = options.sortObj.sortFieldValue;
        const sortDir = options.sortObj.sortDir;
        results.sort((a, b) => {
          let aValue = a[sortField] || '';
          let bValue = b[sortField] || '';
          
          if (typeof aValue === 'string') {
            aValue = aValue.toLowerCase();
            bValue = bValue.toLowerCase();
          }
          
          if (sortDir) {
            return aValue > bValue ? 1 : -1;
          } else {
            return aValue < bValue ? 1 : -1;
          }
        });
      }

      // Apply client-side pagination
      const startIndex = options.page * options.pageSize;
      const endIndex = startIndex + options.pageSize;
      const paginatedResults = results.slice(startIndex, endIndex);

      processedData.rows = paginatedResults;

      console.log("Final processed data:", processedData);

      setLoaderRunning(false);
      ref.current.complete();

      return processedData;

    } catch (error) {
      console.error("Error in fetchStylesData:", error);
      setLoaderRunning(false);
      ref.current.complete();
      showToastv2("error", "Error fetching styles");
      return {
        rows: [],
        pageCount: 0,
        reportTemplates: []
      };
    }
  };

  const setPagination = (updater) => {
    const newPagination = updater({
      pageIndex,
      pageSize,
    });
    setPageIndex(newPagination.pageIndex);
    setPageSize(newPagination.pageSize);
  };

  const handleUserClick = (cell) => {
    console.log("Row clicked:", cell.row.original);
    setSelectedRow(cell.row.index);
    setSelectedStyle(cell.row.original);
  };

  const handleEdit = (styleId) => {
    navigate(`/styles/edit/${styleId}`);
  };

  const deleteConfirmModal = (style) => {
    setStyleToDelete(style);
    setShowDeleteConfirmModal(true);
  };

  const deleteStyle = async () => {
    if (!styleToDelete) return;
    
    setLoaderRunning(true);
    ref.current.continuousStart();

    try {
      const response = await deleteStyleApi({ id: styleToDelete.id });

      if (response.status === 200 && response.data.result === "SUCCESS") {
        showToastv2(TOAST_TYPE.SUCCESS, "Style deleted successfully");
        setShowDeleteConfirmModal(false);
        setStyleToDelete(null);
        
        // Update the local state to remove the deleted item 
        if (dataQueryState?.data?.rows) {
          const updatedRows = dataQueryState.data.rows.filter(
            (row) => row.id !== styleToDelete.id
          );
          setDataQueryState({
            ...dataQueryState,
            data: {
              ...dataQueryState.data,
              rows: updatedRows
            }
          });
          
          // If the deleted item was selected, select the first item in the updated list
          if (selectedStyle?.id === styleToDelete.id) {
            setSelectedStyle(updatedRows[0] || null);
            setSelectedRow(0);
          }
        }

        // Refresh the list
        queryClient.invalidateQueries("styles-list");
        if (listViewRef.current) {
          listViewRef.current.refresh();
        }
      } else {
        showToastv2(
          TOAST_TYPE.ERROR,
          response.data.message || "Failed to delete style"
        );
      }
    } catch (error) {
      showToastv2(TOAST_TYPE.ERROR, "Error deleting style");
    } finally {
      setLoaderRunning(false);
      ref.current.complete();
    }
  };

  const columns = [
    {
      accessorKey: "title",
      header: "Report Template",
      cell: (info) => {
        const value = info.getValue();
        const modality = info.row.original.modality || "DX";
        return (
          <div style={{ 
            padding: "8px 0", 
            display: "flex", 
            justifyContent: "space-between", 
            alignItems: "center",
            width: "100%",
            boxSizing: "border-box"
          }}>
              <div style={{ 
                overflow: "hidden", 
                textOverflow: "ellipsis", 
                whiteSpace: "nowrap",
                fontWeight: "500",
                marginBottom: "4px",
                width: "100%"
              }}>
                {value}
              </div>
            <div style={{ display: "flex", gap: "10px", marginRight: "15px", flexShrink: 0 }}>
              <Icon
                iconName="Edit"
                style={{
                  fontSize: 17,
                  cursor: "pointer"
                }}
                onClick={() => handleEdit(info.row.original.id)}
              />
              <Icon
                iconName="Delete"
                style={{
                  fontSize: 17,
                  cursor: "pointer"
                }}
                onClick={() => deleteConfirmModal(info.row.original)}
              />
            </div>
          </div>
        );
      },
      show: true,
      headerClass: "list-view-header-cell",
      className: "list-view-cell",
      style: { width: "100%" },
      headerStyle: { width: "100%" }
    }
  ];

  const SelectedRowComponent = () => {
    if (!selectedStyle) return null;
    
    return (
      <div style={{ 
        height: "100%", 
        backgroundColor: getAlterColor("background-color"),
        display: "flex",
        flexDirection: "column",
        justifyContent: "flex-start"
      }}>
        <div style={{
          width: "94%",
          height: "100%",
          margin: "5px 20px",
          backgroundColor: "#ffffff",
          border: getThemeColor("border"), 
          borderRadius: "10px",
          padding: "10px", 
          overflow: "auto"
        }}>
          <div style={{
            fontFamily: "Arial, sans-serif",
            fontSize: "14px",
            color: "#000000",
            whiteSpace: "pre-wrap",
            wordBreak: "break-word"
          }}>
            {selectedStyle.styles}
          </div>
        </div>
      </div>
    );
  };

  return (
    <>
      {authenticated && (
        <div className="main-container-body">
          {showDeleteConfirmModal && (
            <ConfirmModal
              handleConfirm={deleteStyle}
              handleNotConfirm={() => setShowDeleteConfirmModal(false)}
              showConfirmModal={showDeleteConfirmModal}
              message={t("Are you sure you want to delete this style?")}
              title={t("Confirm Delete")}
              confirmButtonText={t("Delete")}
            />
          )}
          <div className="breadCrumb">
            <CustomBreadCrumb items={breadCrumbItems} />
          </div>
          <div
            style={{
              padding: "0px 3px",
              boxSizing: "border-box",
              marginTop: "10px",
              height: "calc(100% - 101px)",
            }}
          >
            <MyStylesTabSection />
            <div
              style={{
                borderBottom: getThemeColor("border"),
                width: "100%",
                boxSizing: "border-box",
              }}
            ></div>
            <SortPopupFilterSectionV4
              handleApplyClick={handleApplyClick}
              placeholder="Search templates..."
              buttonsTopBar={buttonsTopBar}
            />
            <style>
              {`
                .list-view-tr {
                  width: 100% !important;
                }
                .list-view-thead-tr {
                  width: 100% !important;
                }
                .list-view-tbody {
                  width: 100% !important;
                }
                .list-view-table {
                  width: 100% !important;
                }
              `}
            </style>
            <QueryClientProvider client={queryClient}>
              <ListViewTableV3
                columns={columns}
                pageIndex={pageIndex}
                pageSize={pageSize}
                setPagination={setPagination}
                fetchData={fetchStylesData}
                dataQueryState={dataQueryState}
                setDataQueryState={setDataQueryState}
                sortObj={sortObj}
                filterObj={filterObj}
                showPagination={true}
                tabHeaderPresent={true}
                listViewLoading={listViewLoading}
                setListViewLoading={setListViewLoading}
                listViewRef={listViewRef}
                handleUserClick={handleUserClick}
                selectedRow={selectedRow}
                showSideBySide={true}
                selectedRowComponent={<SelectedRowComponent />}
              />
            </QueryClientProvider>
          </div>
        </div>
      )}
    </>
  );
};

export default MyStyles;